export default function RailTypeHeadController(
    $scope,
    $controller
) {
    'ngInject';

    $controller('TypeaheadRailBaseController', {
        $scope,
        cfg: {
            searchLocationsUrl: '/staticdata/SearchEurostarStations',
        },
    });
}



// WEBPACK FOOTER //
// ./src/app/modules/ukrail/controllers/ukrailTypeaheadCtrl.js